
import { Route, Routes } from 'react-router-dom';
import Header from './components/Header/Header';
import Home from './components/Home/Home';
import Reviews from './components/Reviews/Reviews';
import Dashboard from './components/Dashboard/Dashboard';
import Blogs from './components/Blogs/Blogs';
import About from './components/About/About';
import NotFound from './components/NotFound/NotFound';

function App() {
  return (
    <div className="">
      <Header></Header>
      <Routes>
        <Route path='/' element={<Home></Home>}>Home</Route>
        <Route path='/reviews' element={<Reviews></Reviews>}>Home</Route>
        <Route path='/dashboard' element={<Dashboard></Dashboard>}>Home</Route>
        <Route path='/blogs' element={<Blogs></Blogs>}>Home</Route>
        <Route path='/about' element={<About></About>}>Home</Route>
        <Route path='*' element={<NotFound></NotFound>}>Home</Route>
      </Routes>
    </div>
  );
}

export default App;
